import { Button, Card, CardContent, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import type { FirmwareModelMapping, FirmwareUpstream } from "../../../types";

interface ModelMappingsCardProps {
  modelMappings: FirmwareModelMapping[];
  upstreams: FirmwareUpstream[];
  mappingVendor: string;
  mappingModel: string;
  mappingUpstreamId: number | "";
  setMappingVendor: (value: string) => void;
  setMappingModel: (value: string) => void;
  setMappingUpstreamId: (value: number | "") => void;
  onSaveMapping: () => void;
}

export function ModelMappingsCard({
  modelMappings,
  upstreams,
  mappingVendor,
  mappingModel,
  mappingUpstreamId,
  setMappingVendor,
  setMappingModel,
  setMappingUpstreamId,
  onSaveMapping,
}: ModelMappingsCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>Model to Upstream Mapping</Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1} sx={{ mb: 2 }}>
          <TextField
            label="Model Vendor"
            value={mappingVendor}
            onChange={(e) => setMappingVendor(e.target.value)}
            fullWidth
          />
          <TextField
            label="Model Name"
            value={mappingModel}
            onChange={(e) => setMappingModel(e.target.value)}
            fullWidth
          />
          <TextField
            label="Upstream"
            value={mappingUpstreamId}
            onChange={(e) => setMappingUpstreamId(Number(e.target.value) || "")}
            select
            SelectProps={{ native: true }}
            fullWidth
          >
            <option value="">Select upstream</option>
            {upstreams.map((upstream) => (
              <option key={upstream.id} value={upstream.id}>
                {upstream.vendor} / {upstream.name}
              </option>
            ))}
          </TextField>
          <Button variant="contained" onClick={onSaveMapping} disabled={!mappingUpstreamId}>
            Save Mapping
          </Button>
        </Stack>
        {modelMappings.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No model mappings configured.</Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Vendor</TableCell>
                <TableCell>Model</TableCell>
                <TableCell>Upstream</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modelMappings.map((mapping) => (
                <TableRow key={mapping.id}>
                  <TableCell>{mapping.vendor}</TableCell>
                  <TableCell>{mapping.model}</TableCell>
                  <TableCell>{mapping.upstream_vendor} / {mapping.upstream_name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
